import { motion } from "framer-motion";

const steps = [
  {
    num: "01",
    title: "Connect your accounts",
    body: "Log in with your ad platform, pick the accounts you want managed, and 5ads.ai syncs campaigns, ads, audiences and leads live.",
  },
  {
    num: "02",
    title: "Your AI team proposes",
    body: "Every few hours the AI studies performance and lead quality, then drafts budget changes, new creatives and copy — with reasoning.",
  },
  {
    num: "03",
    title: "You approve, it executes",
    body: "Actions wait in your approval queue. One click executes on real campaigns within your guardrails. Nothing ships without you.",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 },
  }),
};

export default function Manifesto() {
  return (
    <section id="how" className="py-24 md:py-32 bg-neutral-950 text-white" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          custom={0}
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
        >
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-400">02 — How it works</p>
          <h2 className="font-heading font-medium tracking-tight text-3xl md:text-4xl mt-4 max-w-2xl">
            Connect. AI proposes. <span className="text-[#FF6B2C]">You approve.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-12 mt-16">
          {steps.map((s, i) => (
            <motion.div
              key={s.num}
              custom={i + 1}
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              className="border-t border-neutral-800 pt-8"
              data-testid={`manifesto-step-${s.num}`}
            >
              <span className="font-mono text-sm text-[#FF6B2C]">{s.num}</span>
              <h3 className="font-heading text-xl font-medium mt-4">{s.title}</h3>
              <p className="text-neutral-400 leading-relaxed mt-3 text-sm md:text-base">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
